module.exports = __webpack_public_path__ + "img/int-coloured.27bc3286.svg";